import { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/shared/ui/button.tsx";
import { ArrowUpDown } from "lucide-react";
import { SetStateAction } from "react";

export const ColumnHistory = (
  setEventId: React.Dispatch<SetStateAction<number>>
):ColumnDef<{
  event_id: number;
  event_name: string;
  event_type: string;
  activity: string;
  start_date: string;
  end_date: string
}>[] => [
    {
      accessorKey: "event_id",
      header: "Event ID",
    },
    {
      accessorKey: "event_name",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Event Name
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
    },
    {
      accessorKey: "event_type",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Event Type
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
    },
    {
      accessorKey: "activity",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Activity
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
    },
    {
      accessorKey: "start_date",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Start Date
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
    },
    {
      accessorKey: "end_date",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            End Date
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
    },

    {
      header: "Action",
      cell: ({ row }) => {
        console.log(row.original.event_id)
        return (
          <Button onClick={() => {
            setEventId(row.original.event_id)
          }}>Explore</Button>
        )
      },
    },
  ];
